// Marca centralizada — trocar aqui quando o nome final do produto for definido.
export const BRAND = {
  name: 'Projectlys',
  tagline: 'Sistema de gestão de projetos e tarefas',
  shortName: 'PL',
  copyrightOwner: 'Projectlys',
  year: 2026,
};
